var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HomeHero'),_c('HomeInfo'),_c('HomePerks'),_c('HomeSteps'),_c('HomePricing'),_c('HomeFaq'),_c('HomeCta'),_c('HomeContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }